const formatters = {
  doors: (value: any) => value > 0 && `${value} doors`,
}

const NULL_STRING = '-'

type VehicleSummary = Cinch.DealerVehicleSummaryResponse | Cinch.DealerVehicleAdvertSummary

export default (vehicle: VehicleSummary) => {
  const allValues = { ...vehicle }

  return Object.keys(vehicle).reduce((returnObject, key) => {
    const value = allValues[key as keyof VehicleSummary]

    if (value === 'unlisted') {
      return { ...returnObject, [key]: NULL_STRING }
    }

    // eslint-disable-next-line no-prototype-builtins
    if (formatters.hasOwnProperty(key)) {
      return { ...returnObject, [key]: formatters[key as keyof typeof formatters](value) || NULL_STRING }
    }

    return { ...returnObject, [key]: value }
  }, {}) as VehicleSummary
}
